export const FEEDBACK = 'Feedback';
export const FEEDBACK_VIEW = 'feedback_view';
export const FEEDBACK_CREATE = 'feedback_create';
export const FEEDBACK_EDIT = 'feedback_edit';
export const FEEDBACK_TYPE = 'feedback_type';
export const FEEDBACK_IMAGE_TYPE = 'feedback';

export const FEEDBACK_ADD_ACTIVITY_TAB = ['Details'];
export const UNITS = ['Kilometers', 'Miles'];
export const INFORMATION_TYPES = [
  { value: 'EMAIL', label: 'Email' },
  { value: 'URL', label: 'URL' },
  { value: 'PHONE', label: 'Phone Number' },
];
export const DESITINATION = [
  { id: 'Check-in', name: 'Check-in', selected: false },
  { id: 'In-Room Dining', name: 'In-Room Dining', selected: false },
  { id: 'Restaurant Booking', name: 'Restaurant Booking', selected: false },
  { id: 'Spa Booking', name: 'Spa Booking', selected: false },
  {
    id: 'Meetings & Events Booking',
    name: 'Meetings & Events Booking',
    selected: false,
  },
  { id: 'Experience Booking', name: 'Experience Booking', selected: false },
  { id: 'Check-out', name: 'Check-out', selected: false },
];

export const FEEDBACK_TYPES = [
  { id: 'Rating (5 Stars)', name: 'Rating (5 Stars)', selected: false },
  { id: 'Yes / No', name: 'Yes / No', selected: false },
];
